<div class="page-seo-data">
  <div id="seo-data" class="seo-data"></div>
</div>

<footer class="footer">
  @if (isBrowser) {
    <section class="footer-1">
      <div class="flex-container ion-align-items-center ion-justify-content-between footer1-col">
        <div class="footer-logo">
          <a href="https://bag2bag.in/" aria-label="bag2bag" class="web-logo">
            <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/logo/footer-new-logo.webp'"
                 alt="footer-new-logo" width="164" height="72" loading="lazy">
          </a>
        </div>
        <div class="flex-container ion-align-items-center inside-footer-1">
          <div class="property-text">List your property and grow your business</div>
          <div>
            <a class="partner-button" [routerLink]="'/partnership/hotel-registration'" target="_blank">List your
              Property</a>
          </div>
        </div>
      </div>
    </section>
  }

  @if (isBrowser) {
    <section class="med_n_cht">
      <div class="web-media-wrap">
        <div class="customer-chat-web">
          <div class="customer-chat-wrap">
            <div class="customer-chat-img">
              <img
                [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/customer-support-1.png'"
                alt="customer-support" width="150" height="150" loading="lazy">
            </div>
          </div>
          <div class="chat-details">
            <div class="chat-inner-details">
              <div class="hlp_n_sprt">HELP & SUPPORT</div>
              <p>Let's take a step ahead and help you better.</p>
            </div>
          </div>
          <div>
            <button class="get-help" (click)="openChatBox()">Chat with Us</button>
          </div>
        </div>
        <div class="subscription-wrap-web">
          <div class="subscription-wrap">
            <div class="image-subscribe">
              <div class="newsletter-flex">
                <div class="img-wrap">
                  <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/newsletter-webp.webp'"
                       alt="newsletter" width="50" height="50" loading="lazy">
                </div>
                <div class="subscribe-content">
                  <div class="title">SUBSCRIBE TO NEWSLETTER</div>
                  <p>Get Notified on New Offers and Deals</p>
                </div>
              </div>
              <div class="mail-wrap">
                <div class="mail-field">
                  <input type="email" name="email" #emailId placeholder="Email Address">
                  <button (click)="submit(emailId?.value)">Subscribe</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="customer-chat-mob">
        <div class="customer-chat-wrap">
          <div class="customer-chat-img">
            <img
              [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/customer-support-1.png'"
              alt="customer-support" width="150" height="150" loading="lazy">
          </div>
          <div class="chat-details">
            <div class="chat-inner-details">
              <div class="title">Help & Support</div>
              <div class="desc">Let's take a step ahead and help you better.</div>
            </div>
            <div>
              <button class="get-help" (click)="openChatBox()">Chat with Us</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  }

  <section class="footers">
    <section class="footer-2">
      <div class="footer-links-seo-data"></div>
      <div class="footer">
        <div class="footer-grid-box">
          <div class="col">
            <div class="footer-heading">BAG2BAG</div>
            <div>
              <div class="footer-content"><a [routerLink]="'/company/about-us'">About</a></div>
              <div class="footer-content"><a [routerLink]="'/careers'">Careers</a></div>
              <div class="footer-content"><a [routerLink]="'/blogs'" target="_blank">Blogs</a></div>
              <!--div class="footer-content"><a [routerLink]="'/company/membership'">Rewards</a></div>-->
              <!--<div class="footer-content"><a [routerLink]="'/contest'">Contest</a></div>-->
              <div class="footer-content"><a [routerLink]="'/stories'">Stories</a></div>
              <div class="footer-content"><a [routerLink]="'/social-impact'">Social Impact</a></div>
              <div class="footer-content"><a [routerLink]="'/faqs'">FAQ's</a></div>
              <div class="footer-content"><a [routerLink]="'/company/contact-us'">Contact Us</a></div>
            </div>
          </div>
          <div class="col">
            <div class="footer-heading">Services</div>
            <div>
              <div class="footer-content"><a [routerLink]="'/hotels-stay'">Hotels</a></div>
              <div class="footer-content"><a [routerLink]="'/hotels'">Hourly Hotels</a></div>
              <div class="footer-content"><a [routerLink]="'/service-apartments'">Service Apartment</a></div>
              <div class="footer-content"><a [routerLink]="'/homestays'">Homestays & Villas</a></div>
              <div class="footer-content"><a [routerLink]="'/resorts'">Resorts</a></div>
              <div class="footer-content"><a [routerLink]="'/experiences'">Experiences</a></div>
            </div>
          </div>
          <div class="col">
            <div class="footer-heading">Policies</div>
            <div>
              <div class="footer-content"><a [routerLink]="'/company/privacy-policy'">Privacy Policy</a></div>
              <div class="footer-content"><a [routerLink]="'/company/refund-policy'">Refund Policy</a></div>
              <div class="footer-content"><a [routerLink]="'/company/cancellation-policy'">Cancellation Policy</a></div>
              <div class="footer-content"><a [routerLink]="'/company/terms-and-conditions'">Terms & Conditions</a></div>
            </div>
          </div>
          <div class="col">
            <div class="footer-heading">Partner with Us</div>
            <div>
              <div class="footer-content"><a [routerLink]="'/partnership/hotel-registration'" target="_blank">List Your
                Property</a>
              </div>
              <div class="footer-content"><a [routerLink]="'/brand-partnership/ads/promote-your-business'">Promote your
                Business</a>
              </div>
              <div class="footer-content"><a [routerLink]="'/bag2bag-for-business'">Bag2bag for Business</a>
              </div>
            </div>
          </div>
          <div class="col not-mob-view">
            <div class="footer-heading">
                <span class="flex-container ion-align-items-center">
                  <span class="loc-img">
                    <img
                      [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/location-outline.png'"
                      alt="location" width="150" height="150" loading="lazy">
                    </span>
                    Address
                  </span>
            </div>
            <div class="flex-container flex-column contact-info">
              <div class="info">
                #677, 1st Floor, Suite No. 326, 27th Main, 13th Cross, Sector 1, HSR Layout, Bengaluru, Karnataka 560102
              </div>
              <div class="info">
                <a href="mailto:care@bag2bag.in" class="flex-container ion-align-items-center" aria-label="mail">
                      <span class="flex-container ion-align-items-end">
                        <span class="mail-img">
                          <img
                            [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/mail-outline.png'"
                            alt="mail-outline" width="150" height="150" loading="lazy">
                          </span>
                          care&#64;bag2bag.in
                        </span>
                </a>
              </div>
              <div class="info">
                <a href="tel:+91-9335505099" class="flex-container ion-align-items-center" aria-label="mobile">
                        <span class="flex-container ion-align-items-end">
                          <span class="mobile-img">
                            <img
                              [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/call.png'"
                              alt="call" width="150" height="150" loading="lazy">
                            </span>
                            +91-9335505099
                          </span>
                </a>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="footer-heading">Cities Sitemap</div>
            <div>
              <div class="footer-content"><a [routerLink]="'/hotel-stays-all-cities'">Hotels in all Cities</a>
              </div>
              <div class="footer-content"><a [routerLink]="'/hourly-hotels-all-cities'">Hourly Hotels in all Cities</a>
              </div>
              <div class="footer-content"><a [routerLink]="'/homestays-all-cities'">Home Stays in all Cities</a></div>
              <div class="footer-content"><a [routerLink]="'/service-apartments-all-cities'">Service Apartments in all
                Cities</a></div>
              <div class="footer-content"><a [routerLink]="'/resorts-all-cities'">Resorts in all Cities</a></div>
            </div>
          </div>
          <div class="col">
            <div class="footer-heading">Bag2bag Mobile App</div>
            <div>
              <div class="footer-content"><a [routerLink]="'/hotel-booking-app-android'">Hotel Booking App Android</a>
              </div>
              <div class="footer-content"><a [routerLink]="'/hotel-booking-app-ios'">Hotel Booking App Ios</a></div>
            </div>
          </div>
          <div class="col">
            <div class="footer-heading">Offerings</div>
            <div>
              <div class="footer-content"><a [routerLink]="'/membership'">Membership</a></div>
              <div class="footer-content"><a [routerLink]="'/rewards/free-stays'">Freestay</a></div>
              <div class="footer-content"><a [routerLink]="'/refer-and-earn'">Referrals</a></div>
              <div class="footer-content"><a [routerLink]="'/coupons'">Coupons</a></div>
              <div class="footer-content"><a [routerLink]="'/buy-gift-cards-online'">Bag2bag Gift Cards</a></div>
            </div>
          </div>
        </div>
      </div>

      <div class="mob-view">
        <div class="support">
          <div class="footer-heading">
              <span class="loc-img">
                <img
                  [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/location-outline.png'"
                  alt="location" width="150" height="150" loading="lazy">
                </span>
            <span>Address</span>
          </div>
          <div class="flex-container flex-column address-info">
            <div class="info">
              #677, 1st Floor, Suite No. 326, 27th Main, 13th Cross, Sector 1, HSR Layout, Bengaluru, Karnataka 560102
            </div>
          </div>
        </div>
        <div class="support">
          <div class="flex-container flex-column contact-info">
            <div class="info">
              <a href="mailto:care@bag2bag.in" class="flex-container ion-align-items-center" aria-label="mail">
                    <span class="mail-img">
                      <img
                        [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/mail-outline.png'"
                        alt="mail-outline" width="150" height="150" loading="lazy">
                      </span>
                <span>care&#64;bag2bag.in</span>
              </a>
            </div>
            <div class="info">
              <a href="tel:+91-9335505099" class="flex-container ion-align-items-center" aria-label="mobile">
                      <span class="mobile-img">
                        <img
                          [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/call.png'"
                          alt="call" width="150" height="150" loading="lazy">
                        </span>
                +91-9335505099</a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="footer-3 web-view">
      <div class="flex-container ion-justify-content-between icon-footer">
        <div class="app-icon flex-container ion-align-items-center">
          <div class="download">
            Download App on:
          </div>
          <div class="flex-container app-sec">
            <a href="https://apps.apple.com/us/app/bag2bag-hotels-and-homes/id1563969368" target="_blank"
               class="flex-container ion-align-items-center" aria-label="appstore">
              <div class="app-store">
                <img
                  [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/logo-apple-appstore.png'"
                  alt="logo-apple-appstore" width="150" height="150" loading="lazy">
              </div>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.ionicframework.projectx956620" target="_blank"
               class="flex-container ion-align-items-center" aria-label="playstore">
              <div class="play-store">
                <img
                  [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/logo-google-playstore.png'"
                  alt="logo-google-playstore" width="150" height="150" loading="lazy">
              </div>
            </a>
          </div>
        </div>
        <div class="social-icon flex-container ion-align-items-center">
          <div class="download">
            Follow Us on:
          </div>
          <div class="flex-container social-icon-pg">
            <a href="https://www.facebook.com/bag2bag.care" target="_blank" aria-label="Facebook">
              <div class="facebook social-media-icon">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/logo-facebook.png'"
                     alt="logo-facebook" width="150" height="150" loading="lazy">
              </div>
            </a>
            <a href="https://twitter.com/bag2bag_care" target="_blank" aria-label="Twitter">
              <div class="twitter social-media-icon">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/logo-twitter.png'"
                     alt="logo-twitter" width="150" height="150" loading="lazy">
              </div>
            </a>
            <a href="https://www.instagram.com/bag2bag_rooms/" target="_blank" aria-label="Instagram">
              <div class="instagram social-media-icon">
                <img
                  [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/logo-instagram.png'"
                  alt="logo-instagram" width="150" height="150" loading="lazy">
              </div>
            </a>
            <a href="https://www.linkedin.com/company/bag2bag" target="_blank" aria-label="linkedin">
              <div class="linkedin social-media-icon">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/logo-linkedin.png'"
                     alt="logo-linkedin" width="150" height="150" loading="lazy">
              </div>
            </a>
            <a href="https://www.youtube.com/@bag2baghotelsandhomes" target="_blank" aria-label="Youtube">
              <div class="youtube social-media-icon">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/logo-youtube.png'"
                     alt="logo-youtube" width="150" height="150" loading="lazy">
              </div>
            </a>
          </div>
        </div>
        <div class="payment-icon flex-container ion-align-items-center">
          <div class="download">
            We Accept:
          </div>

          <div class="payment-icons flex-container">
            <div>
              <div class="rupay">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/rupay.png'"
                     alt="rupay" width="155" height="108" loading="lazy">
              </div>
            </div>
            <div>
              <div class="upi">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/upi.png'"
                     alt="upi" width="155" height="108" loading="lazy">
              </div>
            </div>
            <div>
              <div class="amex">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/amex.png'"
                     alt="amex" width="155" height="108" loading="lazy">
              </div>
            </div>
            <div>
              <div class="mastercard">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/mastercard.png'"
                     alt="mastercard" width="155" height="108" loading="lazy">
              </div>
            </div>
            <div>
              <div class="paytm">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/paytm.png'"
                     alt="paytm" width="155" height="108" loading="lazy">
              </div>
            </div>
            <div>
              <div class="visa">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/visa.png'"
                     alt="visa" width="155" height="108" loading="lazy">
              </div>
            </div>
            <div>
              <div class="razorpay">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/footer-icons/razorpay.png'"
                     alt="razorpay" width="155" height="108" loading="lazy">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="footer-4">
      <div class="flex-container ion-justify-content-center ion-align-items-center cp-footer">
        © 2025 Bag2Bag Travels And Hospitality Services India Pvt. Ltd. All rights reserved.
      </div>
    </section>
  </section>

</footer>
